import { SofaFormValidator } from '@sofology/sofologycomponents';

export const makeOptional = (validator: SofaFormValidator<string>): SofaFormValidator<string> => {
    return (value: string, isChangedAfterExternalValidation?: boolean) => {
        if (!value || value.trim() === '') {
            return Promise.resolve(null);
        }

        return validator(value, isChangedAfterExternalValidation);
    };
};

export const makeValidatorsOptional = (validators: SofaFormValidator<string>[]): SofaFormValidator<string>[] => {
    return validators.map(makeOptional);
};